define('SuiteCommerce.OrderStatus.OrderFinder.Router',
  [
    'SuiteCommerce.OrderStatus.OrderFinder.SearchForm.View',
    'SuiteCommerce.OrderStatus.OrderFinder.SearchResults.View',
    'SuiteCommerce.OrderStatus.OrderFinder.Order.Model',
    'SuiteCommerce.OrderStatus.Utils',
    'Backbone',
    'underscore'
  ],
  function define(
    SearchForm,
    SearchResults,
    OrderModel,
    Utils,
    Backbone,
    _
  ) {
    'use strict';

    return Backbone.Router.extend({
      initialize: function initialize(application) {
        this.application = application;
        this.model = new OrderModel();
        this.setupOrderDetailsListener();
      },

      routes: function routes() {
        var dynamicRoutes = {};
        dynamicRoutes[this.getOrderFinderRoute() + '(/)'] = 'openOrderFinderPage';
        dynamicRoutes[this.getOrderDetailsRoute() + '(/)'] = 'openOrderDetailsPage';
        return dynamicRoutes;
      },

      getOrderFinderRoute: function getOrderFinderRoute() {
        return Utils.getConfigurationParameter('route');
      },

      openOrderFinderPage: function openOrderFinderPage() {
        var view = new SearchForm({
          application: this.application,
          model: this.model
        });
        view.showContent();
      },

      getOrderDetailsRoute: function getOrderDetailsRoute() {
        return Utils.getConfigurationParameter('route') + '/details';
      },

      openOrderDetailsPage: function openOrderDetailsPage() {
        var searchResults;
        if (!_.keys(this.model.get('details')).length > 0) {
          Backbone.history.navigate(this.getOrderFinderRoute(), { trigger: true });
          return;
        }
        searchResults = new SearchResults({
          application: this.application,
          model: this.model
        });
        searchResults.showContent();
      },

      setupOrderDetailsListener: function setupOrderDetailsListener() {
        var self = this;
        this.model.on('sync', function navigateToOrderDetailsPage() {
          Backbone.history.navigate(self.getOrderDetailsRoute(), { trigger: true });
        });

        this.model.on('destroy', function navigateToOrderFinderPage() {
          self.model.clear();
          Backbone.history.navigate(self.getOrderFinderRoute(), { trigger: true });
        });
      }
    });
  });
